// 瓜田网 - 今日新瓜 / 娱乐吃瓜资讯 mock 数据
// 所有艺人均为虚构称呼或行业代称，内容为娱乐行业动态观察，不构成对任何真实个人的报道。

export interface GuaItem {
  id: number;
  category: string;
  tag: string;
  title: string;
  summary: string;
  author: string;
  heat: number;
  comment: number;
  time: string;
  image: string;
  detail: string[];
}

export const categories = [
  { key: '全部', icon: 'ri-water-flash-line' },
  { key: '影视', icon: 'ri-film-line' },
  { key: '综艺', icon: 'ri-mic-line' },
  { key: '音乐', icon: 'ri-music-2-line' },
  { key: '商业', icon: 'ri-store-2-line' },
  { key: '趣闻', icon: 'ri-emotion-laugh-line' },
];

export const feedItems: GuaItem[] = [
  {
    id: 1,
    category: '影视',
    tag: '热议中',
    title: '古装剧《月满西楼》首播口碑两极 服化道被夸上热搜',
    summary: '新上线的古偶剧首日播放量破纪录，画面质感获赞，但剧情节奏引发网友争议，弹幕与评论区吵成一团。',
    author: '瓜田·影剧线',
    heat: 682000,
    comment: 3412,
    time: '今天 09:40',
    image: 'https://readdy.ai/api/search-image?query=stylized%20flat%20vector%20illustration%20of%20an%20ancient%20chinese%20costume%20drama%20set%20with%20ornate%20palace%20lanterns%20glowing%20warmly%2C%20dramatic%20bokeh%20light%20particles%2C%20warm%20cream%20coral%20and%20sage%20green%20palette%2C%20soft%20cinematic%20atmosphere%2C%20no%20visible%20human%20faces%2C%20clean%20editorial%20composition&width=880&height=560&seq=gua-film-01&orientation=landscape',
    detail: [
      '备受关注的古装剧《月满西楼》于今日中午全集上线，开播两小时站内热度便冲上前三，首日播放量更刷新了该平台今年古偶剧的纪录。前几集美轮美奂的服化道和实景置景被大量网友截图夸赞，多个相关词条登上热搜。',
      '不过随着剧情推进，关于男女主感情线推进速度与配角戏份配比的讨论也随之而来。有人认为叙事偏慢，有人则觉得细腻留白更耐看，弹幕区一度呈现"分阵营站队"的热闹场面。',
      '业内人士分析，此类题材向来"开局即巅峰"，后续能否稳住口碑关键看编剧是否在中期埋足钩子。目前该剧豆瓣短评数已破万，评分仍在波动中，是否值得持续追更还有待观察。',
    ],
  },
  {
    id: 2,
    category: '综艺',
    tag: '新瓜',
    title: '《声浪计划》导师合体路透流出 现场气氛一度引热议',
    description: '今日某档音综录制结束后，一段导师后台互动的花絮在短视频平台疯传，画面里的轻松互动让观众直呼"想看完整版"。',
    summary: '音综录制现场花絮流出，导师们后台互动轻松有爱，网友纷纷喊话节目组放出正片之外的完整花絮。',
    author: '瓜田·综艺组',
    heat: 524000,
    comment: 2188,
    time: '今天 09:10',
    image: 'https://readdy.ai/api/search-image?query=stylized%20flat%20vector%20illustration%20of%20a%20backstage%20music%20variety%20studio%20with%20neon%20stage%20lights%2C%20microphones%20and%20instruments%2C%20soft%20glowing%20bokeh%20and%20confetti%2C%20warm%20cream%20coral%20and%20fresh%20green%20palette%2C%20energetic%20playful%20mood%2C%20no%20visible%20faces%2C%20clean%20editorial%20vector%20style&width=880&height=560&seq=gua-show-02&orientation=landscape',
    detail: [
      '国民音综《声浪计划》昨日完成新一轮竞演录制，今日有媒体在社交平台晒出一段后台"路透"画面，只见几位常驻导师在候场间隙有说有笑，气氛轻松，与台上严肃点评的状态形成鲜明反差。',
      '这段十几秒的画面迅速发酵，"导师后台反差萌""想蹲一个花絮完整版"等话题涌入评论区，节目官方账号评论区也被网友攻占，喊话加更衍生内容。',
      '节目组暂未就花絮内容作出正式回应，但据接近节目的人士透露，官方衍生的"台前幕后"特辑已在筹备中，最快下周与观众见面。这波自来水式的热度，对节目下一期的观看氛围无疑是加分项。',
    ],
  },
  {
    id: 3,
    category: '音乐',
    tag: '热度高',
    title: '新生代歌手新专上线一小时 三首歌同时冲进实时榜前十',
    summary: '人气创作歌手时隔一年半回归，新专辑风格大胆转型，主打歌与抒情慢歌包揽榜单前列，业内惊呼其路人盘强劲。',
    author: '瓜田·音乐线',
    heat: 498000,
    comment: 1890,
    time: '今天 08:50',
    image: 'https://readdy.ai/api/search-image?query=stylized%20flat%20vector%20illustration%20of%20a%20music%20album%20release%20moment%20with%20floating%20records%2C%20headphones%20and%20musical%20notes%2C%20warm%20gradient%20glow%20in%20cream%20coral%20and%20mint%20green%2C%20playful%20celebration%20confetti%2C%20no%20people%2C%20modern%20editorial%20poster%20style&width=880&height=560&seq=gua-music-03&orientation=landscape',
    detail: [
      '沉寂一年半的新生代创作歌手今日零点空降新专辑《春信》，短短一小时，专辑内三首主打歌便同时挤进多个音乐平台实时榜前十，其中抒情主打《慢下来的钟》更登顶新歌榜。',
      '与上一张专辑相比，这张作品在编曲上做了大胆减法，大量采用原声乐器和留白式唱法，风格明显从快节奏转向情绪向叙事，被乐评人评价为"一次清醒而克制的自我表达"。',
      '值得一提的是，专辑实体与黑胶版本开售五分钟便告罄，二手平台的溢价也让不少没抢到的粉丝"欲哭无泪"。发行方随后宣布将加印首批，预计本周内补货上架。',
    ],
  },
  {
    id: 4,
    category: '商业',
    tag: '瓜又来了',
    title: '顶流艺人与某运动品牌合约到期 下一站花落谁家成悬念',
    summary: '代言三年期满未再续约，多方开始押注下一任"品牌代言人"，站姐与营销号纷纷下场分析行程表。',
    author: '瓜田·商业线',
    heat: 465000,
    comment: 2033,
    time: '今天 08:20',
    image: 'https://readdy.ai/api/search-image?query=stylized%20flat%20vector%20illustration%20of%20a%20sneaker%20and%20sportswear%20brand%20deal%20negotiation%20concept%20with%20shopping%20bags%20contract%20documents%20and%20sparkling%20star%20icons%2C%20warm%20cream%20coral%20and%20green%20palette%2C%20clean%20minimal%20editorial%20vector%20art%2C%20no%20faces&width=880&height=560&seq=gua-biz-04&orientation=landscape',
    detail: [
      '据品牌渠道消息，某顶流艺人与国民运动品牌的三年代言合约已于本月底正式到期，双方并未按惯例公布续约动态，引发业内对"下一棒由谁接力"的广泛猜测。',
      '过去三年，该艺人凭借极强的带货能力为品牌贡献了可观的销量增长，其相关同款屡次售罄，因此合约到期消息一出，多个消费品牌被网友"点名接盘"，站姐与营销号甚至开始通过分析其近期行程与造型的配色暗号来"押注"新东家。',
      '有长期跟踪该艺人商业版图的账号分析，其团队目前对代言筛选极为谨慎，除看中品牌调性外，也格外在意合作周期与内容共创空间。至于最终官宣花落谁家，业内普遍认为最快一个月内便会有答案。',
    ],
  },
  {
    id: 5,
    category: '趣闻',
    tag: '有点好笑',
    title: '艺考季片场趣闻刷屏 某演员现场还原"自己当年社死现场"',
    summary: '一位实力派演员在采访中大方自嘲当年艺考时的尴尬名场面，真诚又接地气的回答让弹幕笑到停不下来。',
    author: '瓜田·趣闻组',
    heat: 412000,
    comment: 1667,
    time: '昨天 23:30',
    image: 'https://readdy.ai/api/search-image?query=stylized%20flat%20vector%20illustration%20of%20a%20young%20student%20practicing%20stage%20acting%20with%20a%20spotlight%20and%20script%20pages%2C%20awkward%20yet%20funny%20comic%20mood%2C%20warm%20cream%20coral%20and%20mint%20green%20palette%2C%20playful%20minimal%20editorial%20vector%20art%2C%20no%20recognizable%20faces&width=880&height=560&seq=gua-fun-05&orientation=landscape',
    detail: [
      '正值艺考季，一段过往采访视频被网友重新翻出并疯狂转发。画面里，一位如今颇具口碑的实力派演员被问到"考学时最尴尬的一件事"，他不仅没回避，反而当场用夸张的肢体动作"情景再现"了自己当年把台词背串、还一本正经继续演下去的社死场面。',
      '这段"敢自黑"的还原逗得现场主持人和台下观众前仰后合，弹幕更是一路飘过"原来大神也有翻车时刻""太真实了，这阴影我懂"。',
      '不少网友表示，正是这种不端着、愿意自嘲的松弛感，让他在观众心中的好感度又上了一个台阶。评论区也顺势掀起一场"当年艺考/面试大型翻车现场"的接龙分享，话题热度居高不下。',
    ],
  },
  {
    id: 6,
    category: '影视',
    tag: '实锤?',
    title: '暑期档黑马导演新片立项 网友：这题材我先冲了',
    summary: '凭借口碑小成本片一战成名的青年导演官宣新作，主打现实题材悬疑，官宣当天话题阅读量迅速破亿。',
    author: '瓜田·影剧线',
    heat: 356000,
    comment: 1420,
    time: '昨天 22:15',
    image: 'https://readdy.ai/api/search-image?query=stylized%20flat%20vector%20illustration%20of%20a%20movie%20production%20concept%20with%20a%20film%20clapperboard%20spotlight%20and%20mysterious%20shadow%20silhouettes%2C%20warm%20cream%20coral%20and%20deep%20green%20palette%2C%20cinematic%20intrigue%20mood%2C%20editorial%20vector%20poster%20style%2C%20no%20faces&width=880&height=560&seq=gua-film-06&orientation=landscape',
    detail: [
      '去年以一部小成本现实题材电影成为暑期档口碑黑马的青年导演，今日正式官宣了下一部作品。影片仍延续其擅长的现实主义路线，题材落在"真相与谎言"的悬疑框架内，编剧团队据称磨合了两年之久。',
      '官宣海报与先导文案一经发布，"这题材我先冲了""导演的选材眼光从来不会让人失望"等评论迅速刷屏，相关话题阅读量在当晚便突破一亿。片方同步放出消息，称主演阵容正在敲定阶段，预计今年秋冬开机。',
      '业内人士指出，该导演前作以小博大、以质取胜的打法，给沉寂许久的同类型市场带来了不小信心，也让院线对这部新作的分账预期普遍看高。',
    ],
  },
];

export interface TrendItem {
  id: number;
  title: string;
  category: string;
  mark: '爆' | '热' | '新';
  heat: string;
}

export const trendList: TrendItem[] = [
  { id: 1, title: '《月满西楼》首播口碑两极 服化道被夸上热搜', category: '影视', mark: '爆', heat: '682.4万' },
  { id: 2, title: '音综导师后台花絮流出 网友喊话放完整版', category: '综艺', mark: '爆', heat: '524.1万' },
  { id: 3, title: '新生代歌手新专三首歌齐冲实时榜前十', category: '音乐', mark: '热', heat: '498.2万' },
  { id: 4, title: '顶流代言到期 下任品牌接盘方成悬念', category: '商业', mark: '新', heat: '465.8万' },
  { id: 5, title: '演员自黑还原艺考社死现场 弹幕笑疯', category: '趣闻', mark: '热', heat: '412.6万' },
  { id: 6, title: '口碑导演新片立项 悬疑题材话题破亿', category: '影视', mark: '新', heat: '356.9万' },
  { id: 7, title: '某小花机场穿搭走红 同款搜索量翻十倍', category: '趣闻', mark: '热', heat: '298.3万' },
  { id: 8, title: '年度大秀官宣阵容 两家粉丝已经开撕', category: '综艺', mark: '爆', heat: '267.1万' },
];

export interface TimelineItem {
  time: string;
  event: string;
  type: string;
}

export const todayTimeline: TimelineItem[] = [
  { time: '07:20', event: '《月满西楼》全集上线，首日热度破纪录冲上平台前三', type: '影视' },
  { time: '08:10', event: '新生代歌手《春信》三首主打同时空降实时榜前十', type: '音乐' },
  { time: '08:50', event: '顶流艺人某运动品牌合约到期的消息在业内传开', type: '商业' },
  { time: '09:40', event: '《声浪计划》导师后台花絮流出，话题极速升温', type: '综艺' },
  { time: '11:05', event: '艺考季"演员自黑社死现场"采访视频被顶上前排', type: '趣闻' },
  { time: '12:30', event: '口碑导演新片立项，悬疑题材话题阅读量破亿', type: '影视' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '瓜田网上的内容都是真实发生的吗？',
    a: '瓜田网是面向大众的娱乐动态聚合资讯站，站内内容以行业公开信息、节目宣发动态与多方信源交叉整理为主，属于资讯观察类内容。我们不做针对真实个人的捕风捉影式"定性报道"，涉及争议的部分会尽量标注信源与表述口径，请理性看待，不做依据。',
  },
  {
    q: '信息会实时更新吗？会不会漏掉大瓜？',
    a: '编辑团队会全时段盯守各平台动态，热门事件从出现到成稿通常控制在较短时间窗口内。首页"今日热榜"与"速递时间轴"会随热点滚动补充，错过一整天也没关系，盘点区每晚都会为你汇总当日重点。',
  },
  {
    q: '如何投稿我发现的圈内新动态？',
    a: '非常欢迎！你可以通过页面底部的联系邮箱把线索、截图或链接发给我们，最好注明时间与出处。一旦核实采用，会在文首标注投稿署名。由于来稿较多，未必每一条都能及时回复，请见谅。',
  },
  {
    q: '为什么部分内容用"某艺人""某品牌"代称？',
    a: '当事件尚处于路透、流传阶段，信源还不够完整、正式时，我们会采用行业代称或"传闻待证"的表述，避免过早对个人形成误导。这是瓜田网坚持的采编底线：快可以，但不能为了快而失了分寸。',
  },
  {
    q: '文章可以转载到我的公众号或平台吗？',
    a: '欢迎在注明出处（来源：瓜田网）的前提下进行转载分享，也可私信或邮件申请长期白名单合作。未经授权的商业用途与洗稿搬运，我们保留追责的权利，也谢谢每一位吃瓜同行者对原创的尊重。',
  },
];